import type { ReactNode } from 'react';

/**
 * A aba sem conteúdo ainda — sem ensaio, sem gabarito, sem correção — com o
 * próximo passo, quando há um. Uma aba vazia sem saída seria um beco.
 */
export function EmptyState({
  title,
  note,
  children,
}: {
  title: string;
  note: ReactNode;
  children?: ReactNode;
}) {
  return (
    <section className="card empty-state">
      <h3>{title}</h3>
      <p className="card-note">{note}</p>
      {children && <div className="empty-state-actions">{children}</div>}
    </section>
  );
}

export function TabSkeleton({ label }: { label: string }) {
  return (
    <div
      className="skeleton skeleton-result"
      aria-busy="true"
      aria-label={label}
    />
  );
}
